/**
 * Mask Rut function
 * Takes a string, and then returns a formated rut number
 * @param {*} string 
 * @returns string. Ej: 11.111.111-1
 */
const maskRut = (string) => {
    if (!string) return '';
    if (string.length === 1) return string;

    const cleaned = string.replace(/[^\w]/g, '');

    const num = cleaned.slice(0, -1).replace(/[^\d]/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    const tail = cleaned.slice(-1).replace(/[^a-zA-Z0-9]/g);
    return num ? `${num}-${tail}` : tail;
}

/**
 * Mask Phone Number function
 * Takes a string, and returns a chilean number
 * @param {number} input 
 * @returns string. Ej: +56912345678 
 */
// const maskPhoneNumber = (input) => {
//     console.log("mask phone")
//     // Remove all non-digit characters and the initial '+56' prefix
//     const onlyDigits = input.replace(/\D+/g, '').replace(/^56/, '');

//     // Add the '+56' prefix
//     const numberWithPrefix = `+56${onlyDigits}`;

//     // Limit the input length based on whether it starts with '+569' or not
//     const maxLength = numberWithPrefix.startsWith('+569') ? 12 : 11;

//     // Limit the input length based on the maxLength value
//     return numberWithPrefix.substring(0, maxLength);
// }

const maskPhoneNumber = (input) => {
    // Remove all non-digit characters and the initial '+56' prefix, if present
    const onlyDigits = input.replace(/\D+/g, '').replace(/^\+?56/, '');

    // Add the '+56' prefix, if not already present
    const numberWithPrefix = input.startsWith('+56') ? input : `+56${onlyDigits}`;

    // Limit the input length based on whether it starts with '+569' or not
    const maxLength = numberWithPrefix.startsWith('+569') ? 12 : 11;

    // Limit the input length based on the maxLength value
    return numberWithPrefix.substring(0, maxLength);
};

export {
    maskRut,
    maskPhoneNumber
}